/**
 * Tracks clicks via the redshift clicks table.
 * This is the canonical method of click tracking.
 * See on_site_clicks for click tracking directly linked to an impression.
 */
import routes from 'js/core_pre_webpack/routes';
import { keptAlivePost } from 'js/utils/kept_alive_post';

export type Options = {
  source: string; // Limited to 64 characters
  bucket?: string; // If a test bucket is associated with this click
  entityId?: number | string | null; // If an entity (Work, User, RI, etc) is associated with this click
  extra?: object; // Any additional data to store
};

export const trackClick = ({
  source,
  bucket,
  entityId,
  extra,
}: Options): void => {
  // Skip tracking during server-side rendering
  if (typeof window === 'undefined') {
    return;
  }

  const url = routes.api_v0_clicks_path({ subdomain_param: 'api' });
  keptAlivePost(url, {
    source,
    occurred_at: new Date(),
    bucket,
    entity_id: entityId,
    extra,
    hit_id: window.Aedu?.hit_data?.id,
  });
};

export default trackClick;
